import React from 'react';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative h-[70vh] min-h-[500px] overflow-hidden">
      <div className="absolute inset-0">
        <Image
          src="https://images.unsplash.com/photo-1589267185772-a85549927284"
          alt="Vibrant Mexican street food scene with colorful tacos, fresh ingredients, and authentic cooking setup showcasing traditional preparation methods"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background"></div>
      </div>
      
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="max-w-3xl animate-fade-in">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 text-shadow-md">
            Where Street Meets <span className="text-primary">Soul</span>
          </h1>
          <p className="text-xl sm:text-2xl text-white/90 mb-8 text-shadow-sm">
            Bringing the authentic energy and warmth of Mexican street food culture to Bengaluru's vibrant food scene
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="bg-primary/90 backdrop-blur-sm px-6 py-3 rounded-lg">
              <p className="text-primary-foreground font-semibold">100% Halal Certified</p>
            </div>
            <div className="bg-white/90 backdrop-blur-sm px-6 py-3 rounded-lg">
              <p className="text-foreground font-semibold">Fresh Daily Preparation</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;